import React from "react";
import { useAuth } from "../../../../firebase/AuthContext";
import ChatDemo from "../docsAssets/chatDemo_video.mp4";
import newChatImage from "../docsAssets/newchat_screenshot.png";
import historyDemo from "../docsAssets/chatHistoryDemo_video.mp4";
import copyDemo from "../docsAssets/copychatDemo_video.mp4";
import copyScreenshot from "../docsAssets/copychat_screenshot.png";
import thumbsImage from "../docsAssets/thumbs_screenshot.png";
import thumbsDemo from "../docsAssets/thumbsDemo_video.mp4";

export default function ChatInterface({ isEN }) {
  const { currentUser } = useAuth();
  const [isPreviewOpen, setIsPreviewOpen] = React.useState(false);
  const [previewSrc, setPreviewSrc] = React.useState("");

  const openPreview = (src) => {
    setPreviewSrc(src);
    setIsPreviewOpen(true);
  };

  const closePreview = () => {
    setIsPreviewOpen(false);
    setPreviewSrc(null);
  };

  if (!currentUser) {
    return (
      <div className="flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
            {/* Header with icon */}
            <div className="bg-gradient-to-r from-orange-500 to-red-500 px-6 py-8 text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">
                {isEN ? "Access Required" : "需要存取權限"}
              </h2>
              <p className="text-orange-100 text-sm">
                {isEN ? "Troubleshooting Guide" : "故障排除指南"}
              </p>
            </div>

            {/* Content */}
            <div className="px-6 py-8">
              <div className="text-center mb-6">
                <h3 className="text-gray-800 dark:text-white font-semibold text-lg mb-3">
                  {isEN ? "Please log in to continue" : "請登錄以繼續"}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
                  {isEN
                    ? "You need to be authenticated to access the troubleshooting guide and technical support resources."
                    : "您需要進行身份驗證才能訪問故障排除指南和技術支持資源。"}
                </p>
              </div>

              {/* Features preview */}
              <div className="space-y-3 mb-8">
                <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                  <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                  {isEN ? "Common issues & solutions" : "常見問題和解決方案"}
                </div>
                <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                  {isEN ? "Step-by-step guides" : "分步指南"}
                </div>
                <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                  <div className="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                  {isEN ? "Direct support contact" : "直接支持聯繫"}
                </div>
              </div>

              {/* Login prompt */}
              <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
                <p className="text-center text-gray-700 dark:text-gray-300 text-sm">
                  {isEN
                    ? "Return to the main page to sign in with your account"
                    : "返回主頁面使用您的帳號登入"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center mb-8">
        {/* <div className="w-10 h-10 bg-orange-500 rounded-xl flex items-center justify-center mr-4 shadow-lg">
                    <svg
                        className="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                        />
                    </svg>
                </div> */}
        <div>
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white">
            {isEN ? "AI Chat Interface" : "AI 聊天介面"}
          </h2>
          <p className="text-gray-500 dark:text-gray-400 mt-1">
            {isEN ? "Communicate effectively with AI" : "與AI有效溝通"}
          </p>
        </div>
      </div>
      <div className="space-y-6">
        <div className="bg-slate-200 dark:bg-gray-900/40 rounded-xl p-8 border border-gray-300 dark:border-gray-700 shadow-lg">
          <div className="flex items-center mb-6">
            <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 dark:text-white">
              {isEN ? "How to Use the Chat Interface" : "如何使用聊天介面"}
            </h3>
          </div>

          <div className="space-y-6">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
                                    <svg
                                        className="w-5 h-5 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                        />
                                    </svg>
                                </div> */}
                <div className="text-gray-800 dark:text-white font-semibold text-xl">
                  {isEN ? "Starting a Conversation" : "開始對話"}
                </div>
              </div>
              <p className="text-gray-700 dark:text-gray-300 text-sm mb-4">
                {isEN
                  ? "Type your message in the input field and press Enter or click the send button."
                  : "在輸入框中輸入您的訊息，然後按回車鍵或點擊發送按鈕。"}
              </p>
              <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700">
                <video
                  src={ChatDemo}
                  controls
                  className="w-full h-full object-cover"
                >
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

            <div className="bg-yellow-50 dark:bg-yellow-900/20 rounded-lg p-6 border border-yellow-200 dark:border-yellow-800">
              <div className="flex items-center mb-4">
                {/* <div className="w-8 h-8 bg-yellow-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
                                    <svg
                                        className="w-5 h-5 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-yellow-800 dark:text-yellow-200 font-semibold text-xl">
                  {isEN ? "Pro Tips" : "專業提示"}
                </h4>
              </div>
              <ul className="text-gray-700 dark:text-gray-300 space-y-3">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span>
                    {isEN
                      ? "Use clear and specific questions for better responses"
                      : "使用清晰具體的問題以獲得更好的回复"}
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span>
                    {isEN
                      ? "You can copy responses by clicking the copy button"
                      : "您可以點擊複製按鈕來複製回复"}
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span>
                    {isEN
                      ? "Use thumbs up/down to provide feedback"
                      : "使用喜歡/不喜歡提供反饋"}
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span>
                    {isEN
                      ? "Press Shift+Enter for line breaks in your message"
                      : "按 Shift+Enter 在消息中換行"}
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
                                    <svg
                                        className="w-5 h-5 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13 10V3L4 14h7v7l9-11h-7z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                  {isEN ? "Message Features" : "訊息功能"}
                </h4>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-3">
                  <h5 className="text-orange-500 font-medium">
                    {isEN ? "Available Actions:" : "可用操作:"}
                  </h5>
                  <ul className="text-gray-700 dark:text-gray-300 space-y-2">
                    <li className="flex items-center space-x-3">
                      <span>{isEN ? "Copy message" : "複製訊息"}</span>
                    </li>
                    <li className="flex items-center space-x-3">
                      <span className="text-lg">👍</span>
                      <span>{isEN ? "Like response" : "喜歡這個回應"}</span>
                    </li>
                    <li className="flex items-center space-x-3">
                      <span className="text-lg">👎</span>
                      <span>
                        {isEN ? "Dislike response" : "不喜歡這個回應"}
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="space-y-3">
                  <h5 className="text-orange-500 font-medium">
                    {isEN ? "Keyboard Shortcuts:" : "鍵盤快捷鍵:"}
                  </h5>
                  <ul className="text-gray-700 dark:text-gray-300 space-y-2">
                    <li className="flex items-center space-x-3">
                      <code className="bg-gray-700 text-white px-3 py-1 rounded-lg text-sm border border-gray-600">
                        Enter
                      </code>
                      <span>{isEN ? "Send message" : "發送訊息"}</span>
                    </li>
                    <li className="flex items-center space-x-3">
                      <code className="bg-gray-700 text-white px-3 py-1 rounded-lg text-sm border border-gray-600">
                        Shift+Enter
                      </code>
                      <span>{isEN ? "New line" : "換行"}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
                                    <svg
                                        className="w-5 h-5 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                  {isEN ? "Start A New Chat" : "開始新聊天"}
                </h4>
              </div>
              <div className="flex flex-col gap-4">
                <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700 cursor-pointer transform transition-transform hover:scale-105">
                  <img
                    src={newChatImage}
                    alt="New Chat"
                    role="button"
                    className="w-full h-auto object-cover"
                    onClick={() => openPreview(newChatImage)}
                  />
                </div>
                <p className="text-gray-700 dark:text-gray-300 text-sm">
                  {isEN
                    ? "Click the 'New Chat' button on the sidebar to start a fresh conversation."
                    : '點擊側邊欄的"新聊天"按鈕以開始新的對話​​。'}
                </p>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-8 h-8 bg-purple-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
                                    <svg
                                        className="w-5 h-5 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                  {isEN ? "Continue past conversations" : "繼續過去的對話"}
                </h4>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <p className="text-gray-700 dark:text-gray-300 text-sm">
                    {isEN
                      ? "User has also the option to continue conversations from chat history by selecting a previous chat. This feature is made to enhance user experience to revisit and build upon past interactions with the AI."
                      : "用戶還可以透過選擇先前的聊天記錄來繼續對話。 這項功能旨在提升用戶體驗，讓用戶能夠重新訪問並基於與AI的過去互動進行構建。"}
                  </p>
                  <div className="border-l-4 border-orange-500 pl-4 bg-orange-50 dark:bg-orange-900/20 py-2">
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      {isEN
                        ? "This allows users to revisit and build upon past interactions with the AI."
                        : "這允許用戶重新訪問並基於與AI的過去互動進行構建。"}
                    </p>
                  </div>
                  <div className="border-l-4 border-blue-500 pl-4 bg-blue-50 dark:bg-blue-900/20 py-2">
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      {isEN
                        ? "In the History panel, select a previous chat conversation that user wants to continue from. then directly click the 'continue chat' button to load the chat into the main interface."
                        : '在歷史面板中，選擇使用者想要繼續的先前聊天對話。然後直接點擊"繼續聊天"按鈕將聊天載入到主介面。'}
                    </p>
                  </div>
                </div>
                <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700">
                  <video
                    src={historyDemo}
                    className="w-full h-full object-cover"
                    controls
                  />
                </div>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-8 h-8 bg-cyan-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
                                    <svg
                                        className="w-5 h-5 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                  {isEN ? "Copy AI agent responses" : "複製AI助理的回覆"}
                </h4>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700">
                  <video
                    src={copyDemo}
                    className="w-full h-full object-cover"
                    controls
                  />
                </div>
                <div className="space-y-4">
                  <p className="text-gray-700 dark:text-gray-300 text-sm">
                    {isEN
                      ? "To copy an AI response, simply click the copy icon next to the message. This will copy the text to your clipboard for easy pasting elsewhere."
                      : "要複製AI助理的回覆，只需單擊消息旁邊的複製圖標。這將把文本複製到您的剪貼板，以便輕鬆粘貼到其他地方。"}
                  </p>
                  <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700 cursor-pointer transform transition-transform hover:scale-105">
                    <img
                      src={copyScreenshot}
                      alt="Copy Response"
                      className="w-full h-auto object-cover"
                      role="button"
                      onClick={() => openPreview(copyScreenshot)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-8 h-8 bg-indigo-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
                                    <svg
                                        className="w-5 h-5 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                  {isEN
                    ? "Chat Feedback with Thumbs Up/Down"
                    : "聊天回饋：喜歡/不喜歡"}
                </h4>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <p className="text-gray-700 dark:text-gray-300 text-sm">
                    {isEN
                      ? "We value your feedback based on the responses provided by the AI agent. You can express your satisfaction or dissatisfaction with a response by clicking the thumbs up (like) or thumbs down (dislike) icons next to each message. This feedback helps us improve the AI's performance and tailor its responses to better meet your needs."
                      : "我們重視您對AI助理提供的回應的回饋。您可以點擊每個訊息旁邊的點讚（喜歡）或按一下（不喜歡）圖標來表達您對回复的滿意或不滿意。這些回饋有助於我們改善AI的性能，並根據您的需求量身定制其回應。"}
                  </p>
                  <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700 cursor-pointer transform transition-transform hover:scale-105">
                    <img
                      src={thumbsImage}
                      alt="Feedback Response"
                      className="w-full h-auto object-cover"
                      role="button"
                      onClick={() => openPreview(thumbsImage)}
                    />
                  </div>
                  <div className="border-l-4 border-yellow-500 pl-4 bg-yellow-50 dark:bg-yellow-900/20 py-2">
                    <p className="text-gray-700 dark:text-gray-300 text-sm">
                      {isEN
                        ? "To understand better on your dissatisfaction, please provide additional simple explanation in the feedback form that appears after clicking the thumbs down icon. This helps us identify specific issues and improve future responses."
                        : '為了更了解您的不滿，請在點擊"不喜歡"圖示後，在出現的回饋表單中提供額外的簡單說明。這有助於我們確定具體問題並改善未來的回覆。'}
                    </p>
                  </div>
                </div>
                <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700">
                  <video
                    src={thumbsDemo}
                    className="w-full h-full object-cover"
                    controls
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isPreviewOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
          onClick={closePreview}
        >
          <div
            className="relative max-w-4xl max-h-[90vh] p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-2 right-2 text-white bg-black/40 rounded-full w-8 h-8 flex items-center justify-center"
              onClick={closePreview}
              aria-label="Close preview"
            >
              ×
            </button>
            <img
              src={previewSrc}
              alt="Preview"
              className="w-auto max-w-full max-h-[80vh] rounded-md object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
}
